export const appColors = {
           tableCellTitle: "#196f3d",
    selectedMenu: "#B3CD32",
    selectedMenuText:"black",
           //menu: "#282828",
    menu: "white",
           menuText:"white",
           cardBackground: "#a9cce3",
           cardTitle: "black"
       };

export const appDimension = {
    drawerWidth: 170,
    pageMargin:190
}
